import Parser from 'html-react-parser'
import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { FriendlyDateTime } from '../Date/friendly-date-time'
import { Toast } from '../NarusMaterial'

interface CarePlanToastProps {
  id: string
  clientName: string
  close: (id: string) => void
  message: string
  assignedAt: string
  assignerName: {
    given?: string[]
    family?: string[]
    suffix?: string[]
  }
  patientId: string
  kind?: string
  isNew?: boolean
  urgent?: boolean
}

export function CarePlanToast ({
  id,
  clientName,
  close,
  message,
  assignedAt,
  assignerName,
  patientId
}: CarePlanToastProps): JSX.Element {
  const navigate = useNavigate()

  const handleClose = useCallback((): void => {
    close(id)
  }, [ close, id ])

  function handleCardClick (): void {
    navigate(`/patient/${clientName}/${patientId}/patientFolder`)
  }

  return (
    <Toast onDelete={handleClose}>
      <Content
        onClick={handleCardClick}
        message={message}
        assignedAt={assignedAt}
        assignerName={assignerName}
      />
    </Toast>
  )
}

interface ContentProps {
  message: string
  assignedAt: string
  assignerName: {
    given?: string[]
    family?: string[]
    suffix?: string[]
  }
  onClick: () => void
}

function Content ({ message, assignedAt, assignerName, onClick }: ContentProps): JSX.Element {
  let n = ''

  if (assignerName) {
    const first = assignerName?.given?.[0] ?? ''
    const last = assignerName?.family?.[0] ?? ''
    const suffixes = assignerName.suffix?.join(', ') ?? ''
    n = `${first} ${last} ${suffixes}`
  }

  const description = Parser(message || '')
  return (
    <button
      onClick={onClick}
      className='cursor-pointer'
    >
      <p>{description}</p>
      <span className='time'>{n} on <FriendlyDateTime datetime={assignedAt} /></span>
    </button>
  )
}
